export const ITEM = 'item' as const;
export const LIST = 'list' as const;
